import Collapsible from 'common/components/collapsible/Collapsible';
import ContactInformation from 'domain/components/contact-information/ContactInformation';
import SharedHousingLicenseContainer from 'domain/components/shared-housing-license/SharedHousingLicenseContainer';
import VerifyIdentityContainer from 'domain/components/verify-identity/VerifyIdentityContainer';
import AccountSecurityContainer from '../../domain/components/security/AccountSecurityContainer';
import DeactivateContainer from './deactivate/DeactivateContainer';

interface IProfilePresenter {
  profile: {
    first: string;
    last: string;
    mobile: string;
  };
  pathHash: string;
}

// TODO confirmation alerts for all actions on this page
const ProfilePresenter = (props: IProfilePresenter) => {
  return (
    <>
      <h1>Profile, Identity, Account Settings</h1>
      <h3 className='mb-5'>{`Edit account information by expanding a category.`}</h3>
      <Collapsible
        eventKey='account-security'
        className='mb-3'
        leftHeaderContent={<h3>Account Security</h3>}
        defaultOpen={props.pathHash === '#account-security'}
      >
        <AccountSecurityContainer />
      </Collapsible>
      <Collapsible
        eventKey='contact-information'
        className='mb-3'
        leftHeaderContent={<h3>Contact Information</h3>}
        defaultOpen={props.pathHash === '#contact-information'}
      >
        <ContactInformation />
      </Collapsible>
      <Collapsible
        eventKey='identity-verification'
        className='mb-3'
        leftHeaderContent={<h3>Identity Verification</h3>}
        defaultOpen={props.pathHash === '#identity-verification'}
      >
        <VerifyIdentityContainer />
      </Collapsible>
      <Collapsible
        eventKey='shuol'
        className='mb-3'
        leftHeaderContent={<h3>Shared Housing Unit Operator License</h3>}
        defaultOpen={props.pathHash === '#shuol'}
      >
        <SharedHousingLicenseContainer />
      </Collapsible>
      <Collapsible
        eventKey='deactivate'
        className='mb-3'
        leftHeaderContent={<h3>Deactivate Account</h3>}
        defaultOpen={props.pathHash === '#deactivate'}
      >
        <DeactivateContainer />
      </Collapsible>
    </>
  );
};

export default ProfilePresenter;
